<div [ngClass]="{ 'edit-enabled': !disabled }">
  <cl-image-upload-content
    (click)="!disabled ? openPopup() : null"
    [taskID]="taskID"
    [builder]="builder"
    [checklist]="currentChecklist"
    [number]="number"
    [editor]="editor"
    [roleIds]="roleIds ?? []"
    [roleCodes]="roleCodes"
    [enableColumnsBuilder]="enableColumnsBuilder"
    [disabled]="true"
    [configuration]="radTableConfiguration"
    [date]="date"
    [checklistTemplate]="checklistTemplate"
    [hilite]="hilite"
  ></cl-image-upload-content>
</div>
